// WidgetTable.js
import React from 'react';
import { Table, Button, Checkbox, Whisper, Tooltip } from 'rsuite';
import moment from 'moment';

import WidgetTips from '../widget/WidgetTips';

import '../css/widget/widget.table.css'
import 'rsuite/dist/styles/rsuite-default.css';

const { Column, HeaderCell, Cell, Pagination } = Table;

class WidgetTable extends React.Component
{    
    constructor( props )
    {
        super(props);

        const columnWidth =  this.buildColumnWidth(this.props.options, this.props.columns);

        let page = this.props.page === undefined?1:this.props.page;

        this.state = {
               data : this.props.data,
            columns : this.props.columns,
            options : this.props.options,
               page : page,
            records : this.props.options.records!==undefined ? this.props.options.records : 10, 
        columnWidth : columnWidth,
              total : this.props.total,
           pageFlag : this.props.pageFlag===true,
        componentHeight : this.props.height,
        tableRowHight : this.props.tableRowHight!==undefined ? this.props.tableRowHight : 44,
        checkedKeys : [],
        correlation:false,
        recommend:false
        }

        this.onOperate = this.onOperate.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);    

        this.buildTableHeight = this.buildTableHeight.bind(this);    

        this.buildData = this.buildData.bind(this);
        this.buildColumn = this.buildColumn.bind(this);

        this.handleCheck = this.handleCheck.bind(this);
        this.handleCheckAll = this.handleCheckAll.bind(this);


        // 获取组件自身
        this.myRef = React.createRef();
    }

    /**
     * 操作回调函数
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @returns 
     */
    onOperate(type, data, value, event)
    {
        if( this.props.notify!==undefined )
        {
            return this.props.notify(type, data, value, event);
        }
    }

    handleChangePage(page)
    {
        if( this.props.pageTurning!==undefined )
        {
            this.props.pageTurning(page);
        }

        this.setState({page:page});
    }

    /**
     * 表格多选框选择
     * @param {*} value 
     * @param {*} checked 
     */
    handleCheck(columnName, value, checked)
    {
        const { data } = this.props;

        let { checkedKeys } = this.state;

        const nextCheckedKeys = checked ? [...checkedKeys, value] : checkedKeys.filter(item => item !== value);

        if( this.props.onCheck!==undefined && this.props.onCheck!==null )
        {
            let checkData = [];

            for( let item of data )
            {
                for( let checkedKey of nextCheckedKeys )
                {
                    if( item[columnName]===checkedKey )
                    {
                        checkData.push(item);
                        break;
                    }
                }
            }

            this.props.onCheck(checkData);
        }

        this.setState({ checkedKeys: nextCheckedKeys});
    }
 
     /**
      * 表格多选框全选择
      * @param {*} value 
      * @param {*} checked 
      */
    handleCheckAll(columnName, value, checked) 
    {
        const { data } = this.props;

        const checkedKeys = checked ? data.map(item => item[columnName]) : [];
        
        if( this.props.onCheck!==undefined && this.props.onCheck!==null )
        {
            if( checkedKeys!==undefined && checkedKeys.length>0 )
            {
                this.props.onCheck(data);
            }
            else
            {
                this.props.onCheck(checkedKeys);
            }            
        }

        this.setState({checkedKeys});
    }
    
    /**
     * 计算列宽度
     * @param {*} options 
     * @param {*} columns 
     * @returns 
     */
    buildColumnWidth(options, columns)
    {       
        let contentWidth= 100 , useWidth=0 , columnCount = 0, columnWidth = 0;

        if( columns!==undefined )
        {
            for( var i in columns )
            {
                if( columns[i].properties===undefined || 
                    ( columns[i].properties!==undefined && (columns[i].properties.hasOwnProperty("hidden")===false || columns[i].properties.hidden===false)) )
                {
                    if( columns[i].properties!==undefined && columns[i].properties.width!==undefined )
                    {
                        useWidth += parseFloat(columns[i].properties.width);
                    }
                    else
                    {
                        columnCount = columnCount + 1;
                    }
                }
            }
    
            columnWidth = (contentWidth-useWidth) / columnCount ;  
        }   
        
        return columnWidth;
    }

    /**
     * 计算表格高度
     * @param {*} data 
     * @returns 
     */
    buildTableHeight( data )
    {
        let tableHeight = 40;

        if( data!==undefined && data.length>0 )
        {
            tableHeight += data.length * 46;
        }
        else
        {
            tableHeight += 46;
        }
        
        return tableHeight;
    }

    buildColumn(columns, options)
    {
        let tableColumns = [];

        if( options.check!==undefined && options.check!==null )
        {
            tableColumns.push({"name":options.check.name, "title":"", "type":"string", "properties":{"width":5, check:{name:""}}});
        }

        if( options.isSerial!==false )
        {
            tableColumns.push({"name":"serial", "title":"序号", "type":"integer", "properties":{"width":8}});
        }

        tableColumns.push(...columns);

        return tableColumns;
    }

    buildData(data, options)
    {
        const { page, records} = this.state;

        let tableData = [];
    
        if( options!==undefined && options.isSerial!==false && data!==undefined && data.length>0 )
        {
            for( let i=0; i<data.length; i++ )
            {
                let item = data[i];
                item["serial"] = (page-1)*records + 1 + i;
                tableData.push(item);
            }
        }
         
        if( tableData.length>0 )
        {
            return tableData;
        }
        else
        {
            return data;
        }
    }

    /**
     * 组件渲染之后再调用页面方法
     */
    componentDidMount()
    {

        this.updateRect();
    }
 
    componentDidUpdate()
    {
        this.updateRect();
    }
 
    updateRect()
    {
        if( this.myRef!==undefined )
        {
            if( this.myRef.current!==null )
            {

                let height = 0;

                const {options, total } = this.state;


                const width = this.myRef.current.parentElement.clientWidth;

                let e = this.myRef.current.getElementsByClassName("rs-table-row");

                if(  e!==undefined && e.length>0 )
                {
                    for( let i=0; i<e.length; i++ )
                    {
                        height += e[i].offsetHeight;
                    } 
                }

                let componentHeight = height;
                
                if(options.records!==undefined && total!==undefined &&  options.records<total  )
                {
                    componentHeight += 40;
                }

                if( this.state.componentWidth !== width || this.state.componentHeight !== componentHeight )
                {
                    this.setState({componentWidth:width, tableHeight:height, componentHeight:componentHeight, isFromState:true});
                }
            }   
        }
    }

    render()
    {
        
        let { componentWidth, componentHeight, page, records, checkedKeys, tableHeight, tableRowHight, correlation, recommend } = this.state, pageFlag = false, checked = false, indeterminate = false;

        let { data, columns, options, width, height, total, source='',title,WidgetTableHeight,transformRealmId,allDataHeight } = this.props;
        

        if( options.page!==undefined )
        {
            page = options.page;

            this.state["page"] = page;
        }

        columns = this.buildColumn(columns, options);

        data = this.buildData(data, options);

        if( options!==undefined, options.reverse!==undefined && options.reverse===true)
        {
            data.reverse();
        }

        if( width!==undefined && width!==0 )
        {
            componentWidth = width;
        }

        const columnWidth =  this.buildColumnWidth(options, columns);
        
        if( data!==undefined && data!==null )
        {
            if( total>data.length )
            {
                pageFlag = true;
            }

            // 计算表格高度
            if( tableHeight===0 && data!==undefined )
            {
                tableHeight = this.buildTableHeight( data );

                tableHeight -= 40;
            }

            if(  options.isAutoHeight===true )
            {
                if( pageFlag )
                {
                    componentHeight = tableHeight + 40;
                }
                else
                {
                    componentHeight = tableHeight;
                }
                
            }
            else
            {
                if( height!==undefined && height!==0 )
                {
                    componentHeight = height;
                }

                if( tableHeight>componentHeight )
                {
                    if( pageFlag )
                    {
                       
                    }
                    else
                    {
                        tableHeight = componentHeight;
                    }
                }
            }

            if( checkedKeys.length === data.length ) 
            {
                checked = true;
            } 
            else if( checkedKeys.length===0 ) 
            {
                checked = false;
            } 
            else if( checkedKeys.length>0 && checkedKeys.length<data.length ) 
            {
                indeterminate = true;
            }

            if( data.length>0 && columns!==undefined && columns.length>0 )
            {
                return (
                    <div  ref={this.myRef} className="widget-table" style={WidgetTableHeight?{height:"auto"}:allDataHeight?{height:allDataHeight}:{height:componentHeight+40,minHeight:"530px"}}>
                        <Table 
                            height = {tableHeight} data={data} bordered
                            rowClassName="table-row" headerHeight={tableRowHight} rowHeight={tableRowHight}
                        >
                        {
                            columns.map(( item, index ) =>
                            {
                                let width = columnWidth;
                                let hidden = false;
        
                                if( item.properties!==undefined )
                                { 
                                    if( item.properties.width!==undefined )
                                    {
                                        width = parseFloat(item.properties.width);
                                    } 

                                    if( item.properties.hasOwnProperty("hidden")===true && item.properties.hidden===true )
                                    {
                                        width = 0;
                                    }
                                    
                                    hidden = item.properties.hidden;
                                }

                                if( hidden===undefined || hidden===false )
                                {
                                    let columnWidth = componentWidth * width / 100;

                                    if( item.properties!==undefined && item.properties.hasOwnProperty("check")===true )
                                    {
                                        let title = item.title!==undefined ? item.title : "";

                                        return (
                                            <Column width={columnWidth} align="left" fixed key={index}>
                                                <HeaderCell>
                                                    <div style={{ lineHeight: '40px' }}>
                                                        <Checkbox
                                                            inline
                                                            checked={checked}
                                                            indeterminate={indeterminate}
                                                            onChange={ (value, checked)=> { this.handleCheckAll(item.name, value, checked) } }
                                                        />
                                                        
                                                        <div>{title}</div>
                                                    </div>
                                                </HeaderCell>
                                                <CheckCell dataKey={item.name} checkedKeys={checkedKeys} properties={item.properties} onChange={this.handleCheck}></CheckCell>
                                            </Column>
                                        )
                                    }
                                    else if( item.properties!==undefined && item.properties.hasOwnProperty("operations")===true )
                                    {
                                        return ( 
                                            <Column width={ columnWidth } align="left" fixed key={index}>
                                                <HeaderCell><div>{item.title}</div></HeaderCell>
                                                <TableCell parent = {this} title={title} transformRealmId={transformRealmId} dataKey={item.name} properties={item.properties} onChange={this.onOperate} source={source}></TableCell>
                                            </Column>
                                        )
                                    }
                                    else
                                    {
                                        return ( 
                                            <Column width={ columnWidth } align="center" fixed key={index} >
                                                <HeaderCell>
                                                    {item.title}
                                                    {
                                                        item.isContrast && <Whisper placement="bottomEnd" controlId="control-id-hover" trigger="hover" speaker={item.isContrast}>
                                                            <span className='hover'>?</span>
                                                        </Whisper>
                                                    }
                                                </HeaderCell>
                                                <TableCell parent = {this} title={title} transformRealmId={transformRealmId}  dataKey={item.name} properties={item.properties} onChange={this.onOperate}></TableCell>

                                            </Column>
                                            
                                        )
                                    }
                                }
                                else
                                {
                                    return "";
                                } 
                            })
                        }
                        </Table>
                        
                        <Pagination style={pageFlag===true ? {display:"block"} : {display:"none"} }
                            activePage={page}
                            total={total}
                            classPrefix = {"table-page"}
                            displayLength = {records}
                            showLengthMenu={false}
                            reverse = {true}
                            onChangePage={this.handleChangePage}
                            onChangeLength={this.handleChangeLength}
                            renderTotal = {
                                () => {
                                    return (
                                        <div className="table-page-page-info">
                                            <span>总数: </span>
                                            <span>{total}</span>
                                            <span></span>
                                        </div>
                                    )
                                }
                            } 
                        />
                    </div>
                )
            }
            else
            {
                return (
                    <div className="no-data" ref={this.myRef} >
                        <img src={require('../css/widget/img/no-data.svg')}></img>
                    </div>
                )
            }
        }
        else
        {
            return (
                <div ref={this.myRef} className="widget-table" style={{position:'relative',zIndex:"100"}} >
                    <img className="load" src={require('./../img/frame/loading.gif')} alt="es-lint want to get"/> 
                </div>
            );
        }
        
    }
}

export default WidgetTable



export const TableCell = ({ rowData, parent, dataKey, properties, onChange,source,title,transformRealmId, ...props }) => 
{
    let value = rowData[dataKey];


    if(Object.prototype.toString.call(value)==="[object Object]")
    {
        value = Object.values(value).join()
    }
    else
     if(Array.isArray(value))
    {
        value = value.join()
    }

    if( properties!==undefined  )
    {
        return (
            <Cell {...props} >
            {
                () => {

                    if( properties.format!==undefined )
                    {
                        value = moment(value.time).format(properties.format);
                    }

                    if( properties.transform!==undefined )
                    {
                        if( properties.click!==undefined )
                        {
                            return (
                                <Transform >
                                    <Button appearance='link' onClick={ (e) => {onChange(properties.click, JSON.stringify(rowData), value, e)}} >{value}</Button>
                                </Transform>
                            );
                           
                        }
                        else if( properties.operations!==undefined )
                        {
                            return (
                                <Transform onChange={onChange} properties={properties} dataKey={dataKey} rowData={rowData}>
                                <div className="operations">
                                    <div>
                                            {
                                                properties.operations.map((operation, index) => {
                                                if( operation.type==="icon" && operation.img!==undefined)
                                                {
                                                    let icon = source ? require("../pages/system/img/icon/" + operation.img + '.svg') : require( "../img/riskCompass/table/" + operation.img + '.svg');

                                                    return (
                                                        <div style={ {float:'left', cursor: 'pointer'} } key={index} className={operation.click} 
                                                            onClick={ (e) => {onChange(operation.click, JSON.stringify(rowData), value, e)}} >
                                                            <WidgetTips isRequire={true} icon={icon} tipContent={operation.name} position="top"/>
                                                        </div>
                                                    )
                                                }
                                                else
                                                {
                                                    if( operation.img!==undefined )
                                                    {
                                                        return (
                                                            <div style={ {float:'left', cursor: 'pointer'} } key={index} className={operation.click} 
                                                                onClick={ (e) => {onChange(operation.click, JSON.stringify(rowData), value, e)}} >
                                                                <img src={require('./../img/riskCompass/table/' + operation.img + '.svg')} alt="es-lint want to get" />
                                                                {operation.name}
                                                            </div>
                                                        )
                                                    }
                                                    else
                                                    {
                                                        return (
                                                            <div style={ {float:'left', cursor: 'pointer'} } key={index} className={operation.click} 
                                                                onClick={ (e) => {onChange(operation.click, JSON.stringify(rowData), value, e)}}>
                                                                {operation.name}
                                                            </div>
                                                        )
                                                    }
                                                }

                                                    // return (
                                                    //     <Button appearance='link' onClick={(e) => { onChange(item.click, JSON.stringify(rowData), value, e) } } key={index}>{item.name}</Button>
                                                    // )
                                                })
                                            }
                                    </div>
                                
                                </div>
                                </Transform>
                            )
                        }
                        else
                        {
                           return (
                                <Transform onChange={onChange} properties={properties} dataKey={dataKey} rowData={rowData}>
                                    <span dangerouslySetInnerHTML = {{ __html:value }} > </span>
                                    {/* {value} */}
                                </Transform>
                            )
                        }   
                    }
                    else 
                    {
                        if( properties.click!==undefined )
                        {
                            return <Button appearance='link' onClick={ ( e ) => {onChange(properties.click, JSON.stringify(rowData), value, e)}} >{value}</Button>
                        }
                        else if( properties.operations!==undefined )
                        {
                            return (
                                <div className="operations">
                                    <div>
                                            {
                                                properties.operations.map((operation, index) => {
                                                if( operation.type==="icon" && operation.img!==undefined)
                                                {
                                                    let icon = require("../img/riskCompass/table/" + operation.img + '.svg'); ;

                                                    return (
                                                        <div style={ {float:'left', cursor: 'pointer'} } key={index} className={operation.click} 
                                                            onClick={ (e) => {onChange(operation.click, JSON.stringify(rowData), value, e)}} >
                                                            <WidgetTips isRequire={true} icon={icon} tipContent={operation.name} position="top"/>
                                                        </div>
                                                    )
                                                }
                                                else
                                                {
                                                    if( operation.img!==undefined )
                                                    {
                                                        return (
                                                            <div style={ {float:'left', cursor: 'pointer'} } key={index} className={operation.click} 
                                                                onClick={ (e) => {onChange(operation.click, JSON.stringify(rowData), value, e)}} >
                                                                <img src={require('./../img/riskCompass/table/' + operation.img + '.svg')} alt="es-lint want to get" />
                                                                {operation.name}
                                                            </div>
                                                        )
                                                    }
                                                    else
                                                    {
                                                        return (
                                                            <div style={ {float:'left', cursor: 'pointer'} } key={index} className={operation.click} 
                                                                onClick={ (e) => {onChange(operation.click, JSON.stringify(rowData), value, e)}} >
                                                                {operation.name}
                                                            </div>
                                                            )
                                                        }
                                                    }
                                                })
                                            }
                                    </div>
                                
                                </div>
                            )
                        }
                        else
                        {   
                            if(title){

                                return ( <span title={value}> {value}</span> );

                            }else{
                                    return ( <span> {value}</span> );
                            }
                        }
                    }
                }
            }
            </Cell>
        );
    }
    else
    {
        return (
            <Cell {...props} dataKey={dataKey}>
                <span >{value}</span>
            </Cell>
        );
    }
}

export const Transform = ({ rowData, dataKey, properties, onChange, ...props }) => 
{
    // console.log(props.children.props.dangerouslySetInnerHTML.__html)
    if( onChange !== undefined )
    {
        let arr = []

        if(properties.transform==="transformRelateType"){
                let arr = rowData.relateType.split(",")
                let acc;

                if(arr.length === 1){
                    if(arr[0]  === "1")
                    {
                        return arr[0]=<span title={"股东比例"}>{"股东比例"}</span>
                    }
                    else if(arr[0]  === '2')
                    {
                        return arr[0]= <span title={"企业对外投资"}>{"企业对外投资"}</span>
                    }
                    else if(arr[0]  === '3')
                    {
                        return arr[0] = <span title={"股东对外投资"}>{"股东对外投资"}</span>
                    }
                    else if(arr[0]  === "4")
                    {
                        return arr[0] = <span title={"法人对外投资"}>{"法人对外投资"}</span>
                    }
                    else if(arr[0]  === "5")
                    {
                        return arr[0]= <span title={"高管对外投资"}>{"高管对外投资"}</span>
                    }
                    else if(arr[0]  === "6")
                    {
                        return arr[0] = <span title={"股东对外任职"}>{"股东对外任职"}</span>
                    }
                    else if(arr[0]  === "7")
                    {
                        return arr[0] = <span title={"法人对外任职"}>{"法人对外任职"}</span>
                    }
                    else if(arr[0]  === "8")
                    {
                        return arr[0] = <span title={"高管对外任职"}>{"高管对外任职"}</span>
                    }
                    else if(arr[0]  === "9")
                    {
                        return arr[0] = <span title={"上下游关系"}>{"上下游关系"}</span>
                    }
                    else{
                        return arr[0]  = <span title={"无"}>{"无"}</span>
                    }
                }
                else if(arr.length > 1)
                {
                    let add = []
                    for(let item of arr){
                      if(item  === "1")
                      {
                           item="股东比例"
                           add.push(item)
                      }
                      else if(item  === "2")
                      {
                        item= "企业对外投资"
                        add.push(item)
                      }
                      else if(item  === "3")
                      {
                        item = "股东对外投资"
                        add.push(item)
                      }
                      else if(item  === "4")
                      {
                        item= "法人对外投资"
                        add.push(item)
                      }
                      else if(item  === "5")
                      {
                        item= "高管对外投资"
                        add.push(item)
                      }
                      else if(item  === "6")
                      {
                        item = "股东对外任职"
                        add.push(item)
                      }
                      else if(item  === "7")
                      {
                        item = "法人对外任职"
                        add.push(item)
                      }
                      else if(item  === "8")
                      {
                        item = "高管对外任职"
                        add.push(item)
                      }
                      else if(item  === "9")
                      {
                        item = "上下游关系"
                        add.push(item)
                      }
                      else
                      {
                        item = "无"
                        add.push(item)
                      }
                      arr = add
                    }
                     acc = arr.join(",")
                }
                return  <span title={acc}>{acc}</span>
        }

        return onChange(properties.transform, rowData, props.children)
    }
    else
    {
        return props.children
    }
}

/**
 * 多选框
 * @param {*} param0 
 * @returns 
 */
 export const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, tableRowHight, ...props }) => 
 {
     const { properties } = props;
 
     const { check } = properties; 
 
     if( check.name!==undefined )
     {
         return (
             <Cell {...props} style={{ padding: 0 }}>
                 <div style={{ lineHeight: `${tableRowHight || 46}px` }}>
                 <Checkbox
                     value={rowData[dataKey]}
                     inline
                     onChange={(value, checked)=>{ onChange(dataKey, value, checked) }}
                     checked={checkedKeys.some(item => item === rowData[dataKey])}
                 />
                 {check.name}
                 </div>
             </Cell>
         )
     }
     else
     {
         return (
             <Cell {...props} style={{ padding: 0 }}>
                 <div style={{ lineHeight: `${tableRowHight || 46}px` }}>
                 <Checkbox
                     value={rowData[dataKey]}
                     inline
                     onChange={onChange}
                     checked={checkedKeys.some(item => item === rowData[dataKey])}
                 />
                 </div>
             </Cell>
         )
     }
 }

